exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n#alinear {\n  text-align: justify;\n}\n#divCortaCorriente {\n  font-family: 'Asap', sans-serif !important;\n  font-weight: '14' !important;\n  width: 85%;\n}\n", ""]);

// exports
